const Files = {

  methods: {
    getBase64 (file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.readAsDataURL(file)
        reader.onload = () => resolve(reader.result)
        reader.onerror = error => reject(error)
      })
    },

    downloadFileFromBase64 (dataURI, filename) {
      const blob = this.convertDataURItoBlob(dataURI)
      const url = URL.createObjectURL(blob)

      let link = document.createElement('a')
      link.download = filename
      link.href = url
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    },

    convertDataURItoBlob (dataURI) {
      let byteString = null
      if (dataURI.split(',')[0].indexOf('base64') >= 0) {

        byteString = atob(dataURI.split(',')[1]);
      } else {
        byteString = unescape(dataURI.split(',')[1]);
      }

      let mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0]

      let ia = new Uint8Array(byteString.length)
      for (let i = 0; i < byteString.length; i++) {
        ia[i] = byteString.charCodeAt(i)
      }
      return new Blob([ia], { type: mimeString })
    }
  }
}

export default Files
